export const validateTin = (value: string) => {
  return value && !value.match(/^[0-9]{9}$/) && 'Must have 9 numbers'
}
